import React,{Component} from 'react';
import {variables} from '../../Variables.js';
import MyPage from "../../../src/MyPage";
import SubTabsGeneralParams from "../../../src/SubTabsGeneralParams";
import { isSuperAdmin } from "./../../helpers/user.js";
import axiosService from '../../helpers/axios';


  export default class GeneralParamsTransfertPoDelay extends Component{ 

    constructor(props){
      super(props);

      this.state={
          transfertpodelays:[],
          modalTitle:"",
          transfertpodelay:"",
          transfertpodelayid:0,
      }
  }



refreshList(){
  axiosService.get('/transfertpodelay/')
  .then(response=>{
      const data = response.data?.results ?? response.data;
      this.setState({transfertpodelays:data});
  });
}



componentDidMount(){
  this.refreshList();
}

changeTransfertPoDelay =(e)=>{
  this.setState({transfertpodelay:e.target.value});
}
changeTransfertPoDelayID =(e)=>{
  this.setState({transfertpodelayid:e.target.value});
}

addClick(){
  this.setState({
      modalTitle:"Add TransfertPoDelay",
      transfertpodelayid:0,
      transfertpodelay: "",
  });
}
editClick(dep){
  this.setState({
      modalTitle:"Edit TransfertPoDelay",
      transfertpodelayid:dep.transfertpodelayid,
      transfertpodelay:dep.transfertpodelay,
      intitialTransfertPoDelay:dep.transfertpodelay,
  });
}

createClick() {
  const { transfertpodelay,  } = this.state;

  if (!transfertpodelay) {
    alert('Transfert PoDelay is required');
    return;
  }


  axiosService.post('/transfertpodelaycreate/', {
    transfertpodelay: transfertpodelay
  })
    .then(result => {
      alert('TransfertPoDelay created');
      this.refreshList();
      //window.location.reload(); // Refresh the page
    })
    .catch(error => {
      alert('Failed');
    });
}


updateClick(id){

  const { transfertpodelay, intitialTransfertPoDelay } = this.state;

   // Check if any changes are detected
   if (
    transfertpodelay === intitialTransfertPoDelay
  ) {
    alert('No changes detected');
    return;
  }

  if (!transfertpodelay) {
    alert('Application Name is required');
    return;
  }
  

  axiosService.patch('/transfertpodelay/'+id+'/',{
      transfertpodelayid:this.state.transfertpodelayid,
      transfertpodelay:this.state.transfertpodelay
  })
  .then((result)=>{
      alert('Update succesful');
      this.refreshList();
      //window.location.reload(); // Refresh the page
  })
  .catch((error)=>{
      alert('Failed');
  })
}

deleteClick(id) {
 
  if (window.confirm('Are you sure?')) {
    axiosService.delete('/transfertpodelay/' + id + '/')
      .then(res => {
        alert('Delete successful');
        this.refreshList();
        //window.location.reload(); // Refresh the page
      })
      .catch(error => {
        alert(error?.response?.data?.error || error?.message || 'Delete failed');
      });
  }
}


render(){
  const {
      transfertpodelays,
      modalTitle,
      transfertpodelayid,
      transfertpodelay,
  }=this.state;

  return(
<div className="scrollable-container">
<MyPage />
<SubTabsGeneralParams />
<button type="button"
disabled={!isSuperAdmin()}
className="btn btn-primary m-2 float-end"
data-bs-toggle="modal"
data-bs-target="#exampleModal"
onClick={()=>this.addClick()}
style={{  height: "28px", fontSize: "12px" ,textAlign:"center"}}
>

  Add TransfertPoDelay
</button>
<div className="table-container-single">
<table className="table table-striped">
<thead>
<tr className="header-row-fixed">
  <th style={{  fontSize: "12px" ,textAlign:"center"}}>
      <div className="d-flex flex-row align-items-center justify-content-center">
      <input className="form-control m-2"
       style={{ width: "70px", height:"30px" ,fontSize: "12px"}} // Set the width to 200 pixels (you can adjust the value as needed)
      onChange={this.changeTransfertPoDelayID}
      placeholder="Filter"/>

      </div>
      Transfert PoDelayID
  </th>
  <th style={{  fontSize: "12px" ,textAlign:"center"}}>
  <div className="d-flex flex-row align-items-center justify-content-center">
  <input className="form-control m-2"
   style={{ width: "200px", height:"30px",fontSize: "12px" }} // Set the width to 200 pixels (you can adjust the value as needed)
      onChange={this.changeTransfertPoDelay}
      placeholder="Filter"/>

      </div>
      TransfertPoDelay (months)

  </th>
  <th style={{  fontSize: "12px" ,textAlign:"center"}}>
      Options
  </th>
</tr>
</thead>
<tbody>
  {transfertpodelays.map(dep=>
      <tr key={dep.transfertpodelayid}  className="row-hover">
          <td className="table-text">{dep.transfertpodelayid}</td>
          <td className="table-text">{dep.transfertpodelay}</td>
          <td className="table-text">
          <div style={{ display: "flex", justifyContent: "center" }}>
          <button type="button"
          disabled={!isSuperAdmin()}
          className="btn btn-light mr-1  p-0"
          data-bs-toggle="modal"
          data-bs-target="#exampleModal"
          onClick={()=>this.editClick(dep)}>
              <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="currentColor" className="bi bi-pencil-square" viewBox="0 0 16 16">
              <path d="M15.502 1.94a.5.5 0 0 1 0 .706L14.459 3.69l-2-2L13.502.646a.5.5 0 0 1 .707 0l1.293 1.293zm-1.75 2.456-2-2L4.939 9.21a.5.5 0 0 0-.121.196l-.805 2.414a.25.25 0 0 0 .316.316l2.414-.805a.5.5 0 0 0 .196-.12l6.813-6.814z"/>
              <path fillRule="evenodd" d="M1 13.5A1.5 1.5 0 0 0 2.5 15h11a1.5 1.5 0 0 0 1.5-1.5v-6a.5.5 0 0 0-1 0v6a.5.5 0 0 1-.5.5h-11a.5.5 0 0 1-.5-.5v-11a.5.5 0 0 1 .5-.5H9a.5.5 0 0 0 0-1H2.5A1.5 1.5 0 0 0 1 2.5v11z"/>
              </svg>
          </button>

          </div>

          </td>
      </tr>
      )}
</tbody>
</table>
</div>

<div className="modal fade" id="exampleModal" tabIndex="-1" aria-hidden="true">
  <div className="modal-dialog modal-lg modal-dialog-centered">
    <div className="modal-content">
      <div className="modal-header">
        <h5 className="modal-title" style={{ fontSize: "12px" }} >{modalTitle}</h5>
        <button type="button" className="btn-close" data-bs-dismiss="modal" aria-label="Close"></button>
      </div>
      <div className="modal-body">
      <div className="input-group mb-3">
          <span className="input-group-text" style={{ fontSize: "12px" }} >TransfertPoDelay (months)</span>
          <input
            type="text"
            className={`form-control`}
            value={transfertpodelay}
            onChange={this.changeTransfertPoDelay}
            style={{ fontSize: "12px" }} 
          />
        </div>

        {transfertpodelayid === 0 ? (
          <button type="button" className="btn btn-primary float-start" onClick={() => this.createClick()}>
            Create
          </button>
        ) : null}

        {transfertpodelayid !== 0 ? (
          <button type="button" className="btn btn-primary float-start" onClick={() => this.updateClick(transfertpodelayid)}>
            Update
          </button>
        ) : null}
      </div>
    </div>
  </div>
</div>


</div>
  )
}


  }